<div class="agpr-tableOfContents">
    <div
        [ngStyle]="{
            'background-color': _data?.styles?.backgroundColor,
            'font-weight': _data?.styles?.bold ? 'bold' : 'normal',
            'color': _data?.styles?.color,
            'font-family': _data?.styles?.fontFamily,
            'font-size': _data?.styles?.fontSize,
            'font-style': _data?.styles?.italics ? 'italic' : 'normal',
            'text-decoration': _data?.styles?.underlined ? 'underline' : 'none',
            'line-height': '100%',
            'padding-top': _data?.styles?.padding?.paddingOption
                ? (_data?.styles?.padding?.topPadding) + 'px'
                : (_data?.styles?.padding?.paddingAll) + 'px',
            'padding-right': _data?.styles?.padding?.paddingOption
                ? (_data?.styles?.padding?.rightPadding) + 'px'
                : (_data?.styles?.padding?.paddingAll) + 'px',
            'padding-bottom': _data?.styles?.padding?.paddingOption
                ? (_data?.styles?.padding?.bottomPadding) + 'px'
                : (_data?.styles?.padding?.paddingAll) + 'px',
            'padding-left': _data?.styles?.padding?.paddingOption
                ? (_data?.styles?.padding?.leftPadding) + 'px'
                : (_data?.styles?.padding?.paddingAll) + 'px'
        }"
        class="agpr-tableOfContents"
        [ngClass]="{'agpr-tableOfContents-horizontal': orientation === orientations.horizontal}"
    >
        @for (block of titleBlocks; track index; let index = $index; let isFirst = $first) {
            @if (block.type === blockTypes.TITLE) {
                @if (orientation === orientations.horizontal && !isFirst) {
                    <span class="agpr-tableOfContents-horizontal-separator">|</span>
                }
                <a
                    [class]="'agpr-tableOfContents-title ' + 'agpr-tableOfContents-title--' + block.titleLevel"
                    (click)="scrollTo('block-'+block.index)"
                    [ngStyle]="{
                        'color': _data?.styles?.color,
                    }"
                >
                    {{block.title}} {{includeMentionCount && block.includeMentionCount ? ('(' + (block.mention_count ? block.mention_count : '0')  + ')') : ''}}
                </a>
            } @else if (block.type === blockTypes.CURATED_MENTION_LIST || block.type === blockTypes.AUTOMATIC_MENTION_LIST) {
                @if (includeMentionSections) {
                    @if (orientation === orientations.horizontal && !isFirst) {
                        <span class="agpr-tableOfContents-horizontal-separator">|</span>
                    }
                    <div class="agpr-tableOfContents-mentionSection">
                        <a
                            [class]="'agpr-tableOfContents-title '"
                            (click)="scrollTo('block-'+block.index)"
                            [ngStyle]="{
                                'color': _data?.styles?.color,
                            }"
                        >
                            {{block.title}} {{includeMentionCount ? ('(' + (block.mention_count ? block.mention_count : '0') + ')') : ''}}
                        </a>
                    </div>
                }
                @if (includeHeadlines && orientation === orientations.vertical && block.mentions?.length) {
                    <div class="agpr-tableOfContents-title agpr-tableOfContents-mentions">
                        @for (mention of block.mentions; track mention; let i = $index) {
                            <a
                                [class]="'agpr-tableOfContents-title'"
                                (click)="scrollTo('block-'+block.index, '-mention-' + i)"
                                [ngStyle]="{
                                    'color': _data?.styles?.color,
                                }"
                            >
                                @if (mention.headline) {
                                    {{ mention.headline }}
                                } @else {
                                    {{ mediaTypeNoHeadlineMap.get(mention.mediaType) | localize }}
                                }
                            </a>
                        }
                    </div>
                }
            }
        }
    </div>
</div>
